{
	"name": "returnsportalwebapp",
	"version": "3.0.12-dev.16",
	"scripts": {
		"ng": "ng",
		"version:sync": "node scripts/sync-app-version.cjs",
		"build-dev": " cls && npm version prerelease --preid=dev && ng build -c=development",
		"build-stage": "npm run version:sync && cls && ng build -c=production",
		"build-prod": "cls && npm version patch --no-git-tag-version && ng build -c=production",
		"prestart": "npm run version:sync",
		"start": "ng serve",
		"prebuild": "npm run version:sync",
		"build": "ng build",
		"build:ssr": "ng run ReturnsPortalWebApp:server:dev",
		"e2e": "ng e2e"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "21.2.5",
		"@angular/common": "^21.2.5",
		"@angular/compiler": "21.2.5",
		"@angular/core": "21.2.5",
		"@angular/forms": "21.2.5",
		"@angular/localize": "21.2.5",
		"@angular/platform-browser": "21.2.5",
		"@angular/platform-browser-dynamic": "21.2.5",
		"@angular/platform-server": "21.2.5",
		"@angular/router": "21.2.5",
		"bootstrap": "^5.3.8",
		"rxjs": "^7.8.2",
		"tslib": "^2.8.1",
		"zone.js": "^0.16.1"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^21.2.3",
		"@angular/cli": "^21.2.3",
		"@angular/compiler-cli": "^21.2.5",
		"@angular/language-service": "^21.2.5",
		"@types/jasmine": "^6.0.0",
		"@types/jasminewd2": "^2.0.13",
		"@types/node": "^25.5.0",
		"typescript": "^5.9.3"
	},
	"optionalDependencies": {
		"ts-node": "~10.9.2"
	},
	"overrides": {
		"undici": "^7.24.0"
	},
	"prettier": {
		"singleQuote": true,
		"trailingComma": "all",
		"printWidth": 240,
		"singleAttributePerLine": false,
		"arrowParens": "avoid",
		"tabWidth": 4
	}
}
